import { prefersReducedMotion } from '@theme/utilities';

class SlideshowLogoParallax extends HTMLElement {
  /** @type {number | null} */
  #rafId = null;

  /** @type {HTMLElement | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.slideshow-section');
    if (!this.#section) return;

    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onScroll);
    if (this.#rafId !== null) cancelAnimationFrame(this.#rafId);
  }

  #onScroll = () => {
    if (this.#rafId !== null) cancelAnimationFrame(this.#rafId);
    this.#rafId = requestAnimationFrame(this.#update);
  };

  #update = () => {
    this.#rafId = null;
    if (!this.#section) return;

    const scrolledPast = Math.max(0, -this.#section.getBoundingClientRect().top);

    if (prefersReducedMotion()) {
      this.style.transform = '';
      return;
    }

    // Translate the logo DOWN within the clip container at half scroll speed.
    // This makes the logo appear to move upward slower than the section (parallax),
    // and the overflow:hidden clip container hides it as the section scrolls away.
    this.style.transform = `translateY(${scrolledPast * 0.5}px)`;
  };
}

if (!customElements.get('slideshow-logo-parallax')) {
  customElements.define('slideshow-logo-parallax', SlideshowLogoParallax);
}
